import type { AppState } from "../api";

export const sections = [
  { id: "overview", title: "Обзор сумок", description: "Переход к нужному этапу работы с сумками." },
  { id: "finance", title: "Финансовый кабинет", description: "Балансы владельцев, расходы и финансовые результаты." },
  { id: "funding", title: "Пополнение", description: "Пополнение средств, текущие циклы и история циклов." },
  { id: "purchase", title: "Выкуп", description: "Покупка сумок и сопровождение до склада в Китае.", tabs: [{ id: "new", title: "Новый выкуп", description: "Оформление покупки на средства цикла." }, { id: "tracking", title: "Сопровождение", description: "Проверка после выкупа и путь до склада в Китае." }] },
  { id: "warehouse", title: "Склад и поставки", description: "Сумки на складе в Китае и их доставка в Москву.", tabs: [{ id: "stock", title: "Склад", description: "Сумки, принятые на склад в Китае." }, { id: "shipments", title: "Поставки", description: "Состав и путь поставок, приёмка в Москве и история." }] },
  { id: "preparation", title: "Подготовка", description: "Два этапа после Москвы: вложения и осмотр, затем фото и цена." },
  { id: "listing", title: "Размещение", description: "Подготовка материалов, размещение и обновление объявлений." },
  { id: "shop", title: "Магазин", description: "Сумки в продаже и работа с их объявлениями." },
  { id: "preorders", title: "Предзаказы", description: "Клиентские заказы: от бюджета и покупки до передачи сумки." },
  { id: "history", title: "История действий", description: "Кто, когда и что изменил в приложении." },
  { id: "settings", title: "Настройки", description: "Доступные вашей роли параметры приложения и информация." },
] as const;
const routeTabs: Partial<Record<typeof sections[number]["id"], string[]>> = {
  finance: ["balances", "operations", "reports"], funding: ["current", "history"],
  preparation: ["intake", "photos"], shop: ["sale", "reserved", "sold"],
  preorders: ["active", "history", "accounts"],
};
export type SectionId = typeof sections[number]["id"];
export type Route = { section: SectionId; tab?: string; bagId?: string; gallery?: boolean; objectId?: string };
export function allowedSections(user: Pick<AppState, "can_finance" | "can_publish">) {
  return sections.filter(section => user.can_finance || section.id === "settings" || (user.can_publish && ["listing", "shop"].includes(section.id)));
}
export function defaultSection(user: Pick<AppState, "can_finance" | "can_publish">): SectionId {
  return user.can_finance ? "overview" : user.can_publish ? "listing" : "settings";
}
export function resolveRoute(search: string, user: Pick<AppState, "can_finance" | "can_publish">, hash = ""): Route {
  const query = new URLSearchParams(search);
  if (query.get("section") === "finance" && query.get("tab") === "expenses") query.set("tab", "operations");
  const section = allowedSections(user).find(item => item.id === query.get("section")) || sections.find(item => item.id === defaultSection(user))!;
  const tabs = "tabs" in section ? section.tabs.map(tab => tab.id) : routeTabs[section.id];
  const route: Route = { section: section.id, tab: tabs?.find(tab => tab === query.get("tab")) || tabs?.[0] };
  const bag = query.get("bag") || query.get("product") || new URLSearchParams(hash.replace(/^#/, "")).get("product");
  const permittedTarget = !query.get("section") || query.get("section") === section.id || query.get("section") === "overview";
  if (permittedTarget && ["finance", "overview", "purchase", "warehouse", "preparation", "listing", "shop", "preorders"].includes(section.id) && bag) {
    route.bagId = bag;
    if (query.get("photo") === "1") route.gallery = true;
  }
  if (permittedTarget && query.get("object")) route.objectId = query.get("object")!;
  return route;
}
export function routeUrl(route: Route, href: string) {
  const url = new URL(href);
  url.searchParams.set("section", route.section);
  url.searchParams.delete("product");
  const fragment = new URLSearchParams(url.hash.slice(1));
  if (fragment.has("product")) { fragment.delete("product"); url.hash = fragment.toString(); }
  if (route.objectId) url.searchParams.set("object", route.objectId); else url.searchParams.delete("object");
  if (route.tab) url.searchParams.set("tab", route.tab);
  else url.searchParams.delete("tab");
  if (route.bagId) url.searchParams.set("bag", route.bagId);
  else url.searchParams.delete("bag");
  if (route.bagId && route.gallery) url.searchParams.set("photo", "1");
  else url.searchParams.delete("photo");
  return `${url.pathname}${url.search}${url.hash}`;
}

export const menuGroups: {title:string; ids:readonly SectionId[]}[] = [
  {title:"Сумки", ids:["overview","purchase","warehouse","preparation","listing","shop"]},
  {title:"Деньги", ids:["finance","funding"]},
  {title:"Клиенты", ids:["preorders"]},
  {title:"Прочее", ids:["history","settings"]},
];

export function accessLabel(user: Pick<AppState,"is_owner"|"can_finance">) { return user.is_owner ? "Владелец" : user.can_finance ? "Доступ к финансам" : "Сотрудник"; }
